import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import { TbBrandWhatsapp } from "react-icons/tb";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { LuPartyPopper } from "react-icons/lu";
import { emptyStateIllustrations } from "../assets/empty-states";
import { Button } from "../components/atoms";
import { Card, CardHeader, PageWrapper, QueryState } from "../components/blocks";
import { Apis } from "../util/Apis";

const Promociones = () => {
  const salaInfo = JSON.parse(localStorage.getItem("salaInfo"));
  const mensaje = "Hola, quisiera saber mas sobre las promociones!";
  const imgUrl = "https://wgt-tmp-uploads.s3.amazonaws.com/";

  const { data, isLoading, error } = useQuery({
    queryKey: ["ads-banners", salaInfo?.salaId],
    queryFn: async () => {
      const res = await axios.get(`${Apis.CAPP}/ads-banners?salaId=${salaInfo.salaId}`);
      return res.data;
    },
    enabled: !!salaInfo?.salaId,
  });

  const fullMensaje = salaInfo.whatsapp + encodeURIComponent(mensaje);

  return (
    <PageWrapper>
      <div className="flex flex-col w-full gap-4">
        <Card>
          <CardHeader
            title="Promociones"
            subtitle="Consulte a nuestros asesores sobre nuestras promociones"
            icon={<LuPartyPopper size={24} />}
          />
          <div className="flex flex-col items-center w-full pt-4">
            <Button
              onClick={() => window.open(fullMensaje, "_blank", "noopener,noreferrer")}
              type="button"
            >
              <TbBrandWhatsapp size={18} />
              <span>Contactanos</span>
            </Button>
          </div>
        </Card>

        <QueryState
          data={data}
          isLoading={isLoading}
          error={error}
          emptyProps={{
            title: "No hay promociones disponibles en este momento",
            subtitle: "Vuelva a consultar mas tarde, o pregunte a nuestros asesores",
            illustration: emptyStateIllustrations.promotions,
            illustrationAlt: "Sin promociones disponibles",
          }}
        >
          {(items) => (
            <Swiper
              modules={[Autoplay, Pagination]}
              loop
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{ clickable: true }}
              slidesPerView={1}
              spaceBetween={15}
              initialSlide={0}
              className="w-full"
            >
              {items.map((item) => (
                <SwiperSlide key={item.id} className="w-full py-2">
                  <img className="rounded-xl" src={`${imgUrl}${item.url}`} alt={item.titulo ?? "Promocion"} />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </QueryState>
      </div>
    </PageWrapper>
  );
};

export default Promociones;
